<template>
  <div
    :class="{
      'bg-avtalat-teal': !warning,
      'bg-red-600': warning,
    }"
  >
    <ContainerGrid>
      <div
        :class="{
          'col-span-3': true,
          'text-white': true,
          flex: true,
          'flex-row': true,
          'justify-center': true,
          'align-items-center': true,
          'items-center': true,
          'self-stretch': true,
          'py-sm': true,
          relative: true,
        }"
      >
        <slot></slot>
      </div>
    </ContainerGrid>
  </div>
</template>

<script lang="ts" setup>
import { ContainerGrid } from "@/layout";

defineProps<{
  warning?: boolean;
}>();
</script>
